interface ComputerWithPopUpOverSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithPopUpOverSVG = ({
  color,
  style,
}: ComputerWithPopUpOverSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="52"
    viewBox="0 0 57 52"
    fill="none"
  >
    <g clipPath="url(#clip0_767_3003)">
      <path
        d="M17.0294 14.6372C16.3526 14.6372 15.6915 14.7101 15.0537 14.8429L14.7465 17.3809C13.8485 17.6854 13.0311 18.1644 12.3361 18.7761L9.98287 17.7713C9.10042 18.7475 8.42101 19.9111 8.00452 21.1918L10.0505 22.7276C9.96204 23.178 9.91519 23.6439 9.91519 24.1203C9.91519 24.5966 9.96204 25.0626 10.0505 25.5129L8.00452 27.0488C8.42101 28.3295 9.10042 29.4931 9.98287 30.4692L12.3361 29.4644C13.0337 30.0762 13.8485 30.5551 14.7465 30.8597L15.0537 33.3977C15.6915 33.5331 16.3526 33.6034 17.0294 33.6034M17.0294 26.8613C15.517 26.8613 14.291 25.6353 14.291 24.1229C14.291 22.6105 15.517 21.3844 17.0294 21.3844"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9296 33.5511V40.5326C50.9296 42.1881 49.589 43.5287 47.9334 43.5287H4.46693C2.81136 43.5287 1.47076 42.1881 1.47076 40.5326V12.3619C1.47076 10.7089 2.81136 9.36572 4.46693 9.36572H15.9388"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.56067 37.6641H47.8371"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4209 44.3567V51.0492"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9794 43.5288V51.0491"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.79 51.0491H35.6104"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2132 40.4832H26.1872V40.5092H26.2132V40.4832Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.4468 28.3241C55.0477 28.3241 56.3466 27.0278 56.3466 25.4243V3.55048C56.3466 1.94698 55.0477 0.650635 53.4468 0.650635H23.5971C21.9962 0.650635 20.6973 1.94698 20.6973 3.55048V25.4243C20.6973 27.0278 21.9962 28.3241 23.5971 28.3241H53.4468Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6998 7.67896H56.3492"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1303 4.47976V4.3418"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2592 4.47976V4.3418"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3881 4.47976V4.3418"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7817 13.6426H48.9122"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7817 17.4563H48.9122"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7817 21.2671H42.9511"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.0007 13.7859V21.0772"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1659 13.6765H32.838"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_767_3003">
        <rect
          width="56.18"
          height="51.7001"
          fill={color}
          transform="translate(0.820007)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithPopUpOverSVG;
